var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mostraBloco
    ? _c(
        "div",
        {
          staticClass: "plano-progress ia-block-card",
          attrs: { "data-teste": "plano-progress" }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "ia-block-card__cabecalho ia-block-card__cabecalho--fita"
            },
            [
              _c("icon-svg", {
                staticClass: "ia-block-card__icone",
                attrs: {
                  name: "task-square",
                  size: 14,
                  color: "var(--primary)"
                }
              }),
              _c("span", { staticClass: "ia-block-card__titulo" }, [
                _vm._v(_vm._s(_vm.titulo))
              ])
            ],
            1
          ),
          _c(
            "ol",
            { staticClass: "plano-progress__lista" },
            _vm._l(_vm.passos, function(passo) {
              return _c(
                "li",
                {
                  key: passo.chave,
                  staticClass: "plano-progress__item",
                  class: {
                    "plano-progress__item--concluido": passo.concluido,
                    "plano-progress__item--atual": passo.emAndamento,
                    "plano-progress__item--falhou": passo.falhou
                  },
                  attrs: {
                    "data-teste": "plano-progress-passo-" + passo.estado
                  }
                },
                [
                  _c(
                    "span",
                    { staticClass: "plano-progress__marcador" },
                    [
                      passo.concluido
                        ? _c("icon-svg", {
                            attrs: {
                              name: "check-circle",
                              size: 18,
                              color: "var(--success-text)"
                            }
                          })
                        : passo.falhou
                        ? _c("icon-svg", {
                            attrs: {
                              name: "error-circle",
                              size: 18,
                              color: "var(--danger-text)"
                            }
                          })
                        : _c(
                            "span",
                            {
                              staticClass: "plano-progress__ordem ia-texto-selo"
                            },
                            [_vm._v(_vm._s(passo.ordem))]
                          )
                    ],
                    1
                  ),
                  _c("span", { staticClass: "plano-progress__corpo" }, [
                    _c(
                      "span",
                      {
                        staticClass: "plano-progress__texto ia-texto-auxiliar"
                      },
                      [_vm._v(_vm._s(passo.texto))]
                    ),
                    passo.falhou && passo.erro
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "plano-progress__erro ia-texto-auxiliar"
                          },
                          [_vm._v(_vm._s(passo.erro))]
                        )
                      : _vm._e()
                  ])
                ]
              )
            }),
            0
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }